(function() {
    'use strict';

    angular
        .module('eltazkaraApp')
        .controller('PaymentFailedPopupController', PaymentFailedPopupController);

    PaymentFailedPopupController.$inject = ['$scope', '$rootScope', '$timeout'];

    function PaymentFailedPopupController($scope, $rootScope, $timeout) {
        var vm = this;

        $('.orderCountDown', window.parent.document).fadeOut();

        $timeout(function() {
            $rootScope.$broadcast('timer-stop');
        }, 1000);

        vm.returnToOrders = function() {
            window.top.location = '#/users/orders'
        };
    }

})();